import React, { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { useLocation, Link } from "react-router-dom";
import {
  Button,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  Stack,
} from "@mui/material";

import ConferenceNavbar from "../../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../../AbstractAuth/NewVersion/NewVersionAnstractFooter";

const GroupConferencePaymentRetrunUrl = () => {
  const [paymentRes, setPaymentRes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const eventid = localStorage.getItem("eventid");

  const location = useLocation();
  const pathname = location.pathname;
  const segments = pathname.split("/");

  const encrypt_eventId = segments[segments.length - 1]; // last segment
  const encrypt_participantId = segments[segments.length - 2]; // second last segment

  useEffect(() => {
    const fetchPaymentResponse = async () => {
      try {
        const response = await axios.post(`/api/paytabs/cgpayments/callback`, {
          encrypt_participantId,
          encrypt_eventId,
        });

        if (response.data) {
          setPaymentRes(response.data);
        } else {
          setError("Empty response or invalid data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentResponse();
  }, [encrypt_participantId, encrypt_eventId]);

useEffect(() => {
  if (!paymentRes) return;

  const id = paymentRes?.p_id;
  const hasCancelled = paymentRes.data?.some(
    item => item.status === false && item.message === "Cancelled"
  );

  if (hasCancelled) {
    swal("Payment Incomplete", "Your payment is not complete. Please try again.", "warning");
    
    // Handle cancelled case
    axios.get("/sanctum/csrf-cookie")
      .then(() => axios.post(
        `/api/conference-particepant-cancele-group-online-verification-email-send/${id}`,
        { eventid }
      ))
      .then((res) => {
        if (res.data.status === 200) {
          swal("Cancelled", res.data.message, "info");
        } else {
          swal("Error", "There was an issue sending the email. Please try again later.", "error");
        }
      })
      .catch(() => {
        swal("Error", "An error occurred while sending the email or authenticating request.", "error");
      });
  } else {
    // Handle successful case
    axios.get("/sanctum/csrf-cookie")
      .then(() => axios.post(
        `/api/conference-particepant-group-online-verification-email-send/${id}`,
        { eventid }
      ))
      .then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
        } else {
          swal("Error", "There was an issue sending the email. Please try again later.", "error");
        }
      })
      .catch(() => {
        swal("Error", "An error occurred while sending the email or authenticating request.", "error");
      });
  }
}, [paymentRes, eventid]);

const displayMessage = () => {
  if (paymentRes?.data?.some(item => item.status === false && item.message === "Cancelled")) {
    return "Your payment is not complete. Please try again.";
  }
  return paymentRes?.message || "No message available";
};

  console.log("paymentRes", paymentRes);
  const handleDownloadCSV = () => {
    if (!paymentRes?.wspfr || paymentRes.wspfr.length === 0) return;

    const header = ['ID', 'Name' , 'Email'];
    const rows = paymentRes.wspfr.map(p => [p.id, p.participant_name ,p.participant_email || ""]);

    let csvContent = "data:text/csv;charset=utf-8,"
      + [header, ...rows].map(e => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Group-Participants.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#f9f9f9",
        px: { xs: 2, sm: 4, md: 6 },
        py: 3,
      }}
    >
      {/* <Grid container justifyContent="center" sx={{ mb: 3 }}>
        <Grid item xs={12} sm={10} md={8} lg={6}>
          <ConferenceNavbar />
        </Grid>
      </Grid> */}

      <Box sx={{ textAlign: "right", mb: 2 }}>
        <Button
          component={Link}
          to="/conference/particpant-verification"
          variant="contained"
          color="success"
          size="small"
          sx={{
            ":hover": { bgcolor: "success.dark" },
          }}
        >
          Back To Verification
        </Button>
      </Box>

      <Box
        sx={{
          bgcolor: "white",
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          maxWidth: 700,
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" gutterBottom fontWeight="bold" color="primary">
          Online Payment Status
        </Typography>

        <Typography variant="h6" gutterBottom>
          Note: {displayMessage()}
        </Typography>

        <Typography variant="subtitle1" color="text.secondary" mb={3}>
          Thank you for participating!
        </Typography>

        {/* Participant Names List */}
        {paymentRes?.wspfr && paymentRes.wspfr.length > 0 ? (
          <Box mt={4}>
            <Typography variant="h6" gutterBottom>
              Participant Details:
            </Typography>
            <Stack spacing={2}>
              {paymentRes.wspfr.map((p, idx) => (
                <Card key={idx} variant="outlined">
                  <CardContent>
                    <Typography>
                      QrCode ID: <strong>{p.id}</strong>
                    </Typography>
                    <Typography>
                      Name: <strong>{p.participant_name || "N/A"}</strong>
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </Box>
        ) : (
          <Typography color="text.secondary">No participant data available.</Typography>
        )}
        {paymentRes?.wspfr?.length > 0 && (
          <Box mt={3} textAlign="center">
            <Button
              variant="outlined"
              color="primary"
              onClick={handleDownloadCSV}
            >
              Download as CSV
            </Button>
          </Box>
        )}
      </Box>

      {/* <Grid container justifyContent="center" sx={{ mt: "auto", pt: 3 }}>
        <Grid item xs={12} sm={10} md={8} lg={6}>
          <NewVersionAbstractFooter />
        </Grid>
      </Grid> */}
    </Box>
  );
};

export default GroupConferencePaymentRetrunUrl;
